import React from "react" // from wp-element
import ReactDOM from "react-dom" // from wp-element

import "./frontend.scss"

// document.addEventListener("DOMContentLoaded", function () {

const accordionBlocks = document.querySelectorAll(".mz-accordion-block--uninitialized")

accordionBlocks.forEach(function (div) {
  const title = div.querySelector(".mz-accordion-block__title")
  title.addEventListener("click", e => {
    openBlock(e.target)
  })

  div.classList.remove("mz-accordion-block--uninitialized")
})

function openBlock(block) {
  const container = block.parentElement
  const content = container.querySelector(".mz-accordion-block__content")

  if (content != "") {
    if (!container.classList.contains("active")) {
      closeAllOpenBlocks()
      container.classList.add("active")
      content.style.height = "auto"
      content.style.opacity = "1"

      const height = content.clientHeight + "px"
      content.style.height = "0px"
      setTimeout(function () {
        content.style.height = height
      }, 0)
    } else {
      closeBlock(container)
    }
  }
}

function closeAllOpenBlocks() {
  const openBlocks = document.querySelectorAll(".mz-accordion-block.active")
  openBlocks.forEach(block => closeBlock(block))
}

function closeBlock(block) {
  const content = block.querySelector(".mz-accordion-block__content")
  content.style.height = "0px"
  content.style.opacity = "0"
  content.addEventListener(
    "transitionend",
    function () {
      block.classList.remove("active")
    },
    {
      once: true
    }
  )
}
